module.exports = _.partial;